import { CLEAR_CREATIVE_DRAWER_RESOURCES } from './actionTypes';

const clearCreativeDrawerResources = () => ({
    type: CLEAR_CREATIVE_DRAWER_RESOURCES,
});

export default clearCreativeDrawerResources;
